import { Component, OnInit, Host, ViewChild, Input, Output, ElementRef, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Router } from "@angular/router";
import { MatPaginator, MatSort, MatSlideToggle } from '@angular/material';
import { saveAs as importedSaveAs } from "file-saver";

import { Collana } from '../../../models/Collana';
import { CollanaService } from './../../../services/collana.service';
import { MatTableCustomDataSource, MatTableCustomApi, MatTableCustomDao } from './../../../helpers/mat-table-datasource';
import { AppComponent } from './../../../app.component';

@Component({
  selector: 'app-collana-search',
  templateUrl: './collana-search.component.html',
  styleUrls: ['./collana-search.component.css'],
  providers: [CollanaService],
  encapsulation: ViewEncapsulation.None
})
export class CollanaSearchComponent implements OnInit {
  displayedColumns = ['codice', 'descrizione', 'showcat', 'oldcat', 'ordCatalogo'];
  database: MatTableCustomDao<Collana> | null;
  dataSource: MatTableCustomDataSource<Collana, MatTableCustomApi<Collana>>;

  printing: boolean = false;
  @Input() nested: boolean = false;
  @Output() notify: EventEmitter<Collana> = new EventEmitter<Collana>();

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('qjolly') qjolly: ElementRef;
  @ViewChild('qshowcat') qshowcat: MatSlideToggle;

  filter: EventEmitter<String> = new EventEmitter<String>();

  getTitle(): string {
    return "collane";
  }

  constructor(
    private router: Router,
    public collanaService: CollanaService,
    public parent: AppComponent) { }

  get filters(): any {
    return {
      jolly: this.qjolly.nativeElement.value,
      showcat: this.qshowcat.checked
    }
  }

  onFilterKeypress(event: KeyboardEvent) {
    if (event.keyCode == 13) {
      this.filter.emit(this.filters);
    }
  }

  toggleShowcat(e) {
    console.log('toggleShowcat', e);
    console.log('toggleShowcat', this.qshowcat.checked);
    this.filter.emit(this.filters);
  }

  edit() {
    this.router.navigate(['/collana/' + this.collanaService.selected]);
  }

  add() {
    this.router.navigate(['/collana/']);
  }

  preview() {
    this.router.navigate(['/collana/preview/' + this.collanaService.selected]);
  }

  choose() {
    console.log('chooooose', this.collanaService.selected)
    this.collanaService.getCollana(this.collanaService.selected).subscribe(result => {
      console.log(result)
      if (result.success && result.collana) {
        this.notify.emit(new Collana(result.collana));
      }
    })
  }


  print(ebook: boolean) {
    this.parent.addToast('catalogo', 'anteprima pdf', ((wid) => {
      this.collanaService.print(this.collanaService.selected, ebook).subscribe((res) => {
        this.parent.clearToast(wid);
      })
    }).bind(this))

  }

  download() {
    let wq = this.qjolly.nativeElement.value;
    console.log('download', wq);

    this.parent.addToast('', 'esportazione csv', ((wid) => {
      this.collanaService.downloadFile(wq).subscribe(blob => {
        importedSaveAs(blob, 'collana.csv');
        this.parent.clearToast(wid);
      })
    }).bind(this))

    // this.collanaService.downloadFile(wq).subscribe(blob => {
    //   importedSaveAs(blob, 'collana.csv');
    // })
  }

  highlight(row) {
    this.collanaService.selected = row.codice;
  }

  ngOnInit() {
    this.database = new MatTableCustomDao(this.collanaService);
    this.dataSource = new MatTableCustomDataSource(
      this.database!,
      this.paginator,
      this.sort,
      this.filter,
      false);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/collana/collana-search/collana-search.component.ts